<template>
  <div>
    <fieldset class="border p-2">
      <legend>
        <small style="font-size:15px; font-weight: bold">update user</small>
      </legend>

      <div>
        <form @submit.prevent="userUpdate()">
          <div class="row">
            <div class="col-md-6">
              <input type="hidden" class="id" :value="User.id" />
              <div class="form-group">
                <label>fullnames</label>
                <input
                  type="text"
                  class="form-control fullnames input-rounded f-s-14"
                  :value="User.fullname"
                  placeholder="fullnames"
                  required
                />
              </div>
              <div class="form-group">
                <label>profile name</label>
                <input
                  type="text"
                  class="form-control profilename input-rounded f-s-14"
                  placeholder="profile name"
                  required
                  :value="User.profilename"
                />
              </div>

              <div class="form-group">
                <label>gender</label>
                <select name="gender" class="form-control gender input-rounded f-s-14" :value="User.gender" required>
                  <option value>select gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Email</label>
                <input
                  type="email"
                  class="form-control email input-rounded f-s-14"
                  placeholder="email"
                  :value="User.email"
                  required
                />
              </div>
              <div class="form-group">
                <label>Account status</label>
                <select name='accountstatus'  :value="User.Account_status" class="form-control accontstatus input-rounded f-s-14">
                    {{ User.Account_status === 0 ?
                     <option value="0">Pending</option>: 
                     User.Account_status === 1 ?
                      <option value="1">Active</option> :
                       User.Account_status === 2 ? 
                      <option value="2">Disabled</option> :
                       User.Account_status === 3 ?
                       <option value="3">inActive</option> : ''}}
                </select>
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary btn-flat updatingUser btn-rounded">
            <i class="fa fa-refresh"></i> update user
          </button>
          <button type="button" class="btn btn-primary btn-flat updatingUserLoader btn-rounded">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
          </button>
        </form>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import router from "../router/index"



export default {
  created() {
    if (this.$store.getters.User.length === 0) {
      router.push("/manageusers");
    }
  },
  computed: {
    ...mapGetters(["User"])
  },

  methods: {
    ...mapActions(["userUpdate", "checkPasswordStrength"])
  }
};
</script>
<style scoped>
.updatingUserLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/users/updateuser.vue